import { gql } from "../../../../../gql/__generated__/gql";

export const CREATE_COLLAB_CHECKOUT_SESSION = gql(`
  mutation CreateCollabCheckoutSession($collabId: String!) {
    createCollabFundingCheckoutSession(collabId: $collabId)
  }
`);

export const CREATE_STRIPE_CONNECTED_ACCOUNT = gql(`
  mutation CreateStripeConnectedAccount {
    createStripeConnectedAccount
  }
`);

export const REQUEST_WITHDRAWEL = gql(`
  mutation RequestWithdrawal {
    requestWithdrawal
  }
`);
